export function getErrorList(state) {
    return state.errorList;
}

export function getCallAPI(state) {
    return state.callAPI;
}

export function getLoading(state) {
    return state.isLoading;
}
export function getContentLoading(state) {
    return state.isContentLoading;
}



// WEBPACK FOOTER //
// ./src/app/redux/selectors/selectorCallAPI.js